import { Component, ElementRef, Input, Renderer2 } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { FieldsEditorActionManagerService } from '../../fields-editor/fields-editor-action-manager.service'
import { FieldPlaceholderComponent } from '../field-placeholder.component'
import { SignFieldType } from '@tokeet-frontend/signature'

@Component({
  selector: 'app-data-dic-placeholder',
  templateUrl: './data-dic-placeholder.component.html',
  styleUrls: ['./data-dic-placeholder.component.scss', '../global-fields.scss'],
})
export class DataDicPlaceholderComponent extends FieldPlaceholderComponent {
  type = SignFieldType.DataDic
  @Input() required = false

  constructor(
    render: Renderer2,
    fb: FormBuilder,
    elementRef: ElementRef,
    actionManager: FieldsEditorActionManagerService
  ) {
    super(render, fb, elementRef, actionManager)
  }
}
